import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['root', 'panel']

  connect() {
    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.close()
    }
    document.addEventListener('keydown', this._onKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this._onKeydown)
  }

  open(event) {
    const drawerId = event?.params?.drawerId
    const root = drawerId ? document.getElementById(drawerId) : this.rootTarget
    if (!root) return

    document.body.classList.add('overflow-hidden')
    root.classList.remove('hidden')

    requestAnimationFrame(() => {
      const panel = root.querySelector(
        "[data-hr-portal-slide-over-target='panel']",
      )
      panel?.classList.remove('translate-x-full')
    })
  }

  close() {
    this.panelTarget.classList.add('translate-x-full')

    setTimeout(() => {
      this.rootTarget.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    }, 200)
  }
}
